import React from 'react';
import { useParams } from 'react-router-dom';
import PageBody from '@lib/layouts/DashboardLayout/PageBody/PageBody';
import TaskMenuBar from 'components/TaskMenuBar/TaskMenuBar';
import { TaskViewMode } from './enums';
import TaskViewContainer from './TaskViewContainer';
import TaskFormViewContainer from './TaskFormViewContainer';
import TaskReportingViewContainer from './TaskReportingViewContainer';
import TaskInterventionsContainer from './TaskInterventionsContainer';
import TaskDepartmentsContainer from './TaskDepartmentsContainer';

interface Props {
  viewMode: TaskViewMode;
}

/**
 * Shared shell for the task tabs. Each tab is its own route, but they all
 * resolve to this component so React reconciles instead of remounting on a tab
 * click — only the container below the menu is swapped. Rendering `TaskMenuBar`
 * inside each tab's container instead would mount a fresh `TabBar` every time,
 * and its sliding active indicator can't animate across a remount.
 */
export default function TaskTabsPage({ viewMode }: Props) {
  const { id = '' } = useParams();

  let content: React.ReactNode = null;

  if (viewMode === TaskViewMode.Details) {
    content = <TaskViewContainer />;
  } else if (viewMode === TaskViewMode.Form) {
    content = <TaskFormViewContainer />;
  } else if (viewMode === TaskViewMode.Reporting) {
    content = <TaskReportingViewContainer />;
  } else if (viewMode === TaskViewMode.Interventions) {
    content = <TaskInterventionsContainer />;
  } else if (viewMode === TaskViewMode.Departments) {
    content = <TaskDepartmentsContainer />;
  }

  return (
    <PageBody withoutHeader>
      <TaskMenuBar id={id} />
      {content}
    </PageBody>
  );
}
